import { all } from "redux-saga/effects";
import {
  couponListWatcher,
  couponGetWatcher,
  couponCreateWatcher,
  couponUpdateWatcher,
  couponPauseWatcher,
  couponResumeWatcher,
  couponArchiveWatcher,
  couponSeriesGetWatcher,
  couponSeriesCancelWatcher,
  couponCodeLookupWatcher,
  couponApplyWatcher,
  couponReverseWatcher,
  couponUsageSyncWatcher,
} from "../coupon-saga";

export default function* couponRootSaga() {
  yield all([
    couponListWatcher(),
    couponGetWatcher(),
    couponCreateWatcher(),
    couponUpdateWatcher(),
    couponPauseWatcher(),
    couponResumeWatcher(),
    couponArchiveWatcher(),
    couponSeriesGetWatcher(),
    couponSeriesCancelWatcher(),
    couponCodeLookupWatcher(),
    couponApplyWatcher(),
    couponReverseWatcher(),
    couponUsageSyncWatcher(),
  ]);
}
